import { render } from "./BlogCards.vue?vue&type=template&id=34d20386"
import script from "./BlogCards.vue?vue&type=script&lang=js"
export * from "./BlogCards.vue?vue&type=script&lang=js"

import "./BlogCards.vue?vue&type=style&index=0&id=34d20386&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__